/**
 * Module dependencies.
 */

import { CardGradient } from 'src/components/core/cards/card-gradient';
import { UserInfo } from './user-info';
import { UserInfoConfirm } from './user-info-confirm';
import { UserLocation } from './user-location';
import { media } from '@untile/react-core/styles/media';
import { useSchedule } from 'src/providers/schedule';
import styled from 'styled-components';

/**
 * `Wrapper` styled component.
 */

export const Wrapper = styled(CardGradient)`
  display: grid;
  grid-row-gap: var(--space-xxs);
  grid-template-columns: 100%;
  padding: var(--space-xxs);
`;

/**
 * `ButtonWrapper` styled component.
 */

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: var(--space-xxs);
  justify-content: center;
  padding-top: var(--space-xxs);

  ${media.min.md`
    grid-column: 2;
    justify-content: flex-end;
    padding-top: var(--space-sm);
  `}
`;

/**
 * Export `Steps` component.
 */

export const Steps = () => {
  const { step } = useSchedule();

  return (
    <>
      {step === 1 && <UserLocation />}

      {step === 2 && <UserInfo />}

      {step === 3 && <UserInfoConfirm />}
    </>
  );
};
